export default __webpack_public_path__ + "static/raven-3-b-528b470e1f7757bc4218d6db9eb16e2d.webp";